<template>
    <div>
        <a :href="'/pro/users/' + userDisplay.id + '/edit'">{{ userDisplay.email }}</a>
        <div>
            <a href="#" @click.prevent="open"><i class="fe fe-edit"></i></a>
        </div>
        <el-dialog
            title="Changer utilisateur"
            :visible.sync="dialogVisible"
            width="30%">
            <el-select
                v-model="selectedUser"
                placeholder="Select"
                filterable
                remote
                clearable
                :remote-method="search"
                :loading="loading"
            >
                <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">Annuler</el-button>
                <el-button type="primary" @click="submit">Valider</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ['recipe', 'user'],
    data() {
        return {
            dialogVisible: false,
            users: [],
            selectedUser: null,
            loading: false,
            userDisplay: {}
        }
    },
    mounted() {
        this.selectedUser = this.user.id;
        this.userDisplay = this.user;
        this.users = [{
            id: this.user.id,
            name: `${this.user.fullname} (${this.user.email})`
        }]
    },
    methods: {
        async open() {
            this.dialogVisible = true;
        },
        close() {
            this.dialogVisible = false;
        },
        search(query) {
            if (query !== '') {
                this.loading = true;
                axios.get('/pro/users', {params: {q: query, select: true}})
                    .then(response => {
                        this.users = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        submit() {
            axios.put('/pro/recipes/' + this.recipe + '/change-owner', {user_id: this.selectedUser})
                .then(response => {
                    this.dialogVisible = false;
                    this.userDisplay = response.data.user;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

}
</script>
